import { render, staticRenderFns } from "./RoleQermission.vue?vue&type=template&id=21daa285&scoped=true&"
import script from "./RoleQermission.vue?vue&type=script&lang=js&"
export * from "./RoleQermission.vue?vue&type=script&lang=js&"
import style0 from "./RoleQermission.vue?vue&type=style&index=0&id=21daa285&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21daa285",
  null
  
)

export default component.exports